module.exports = __webpack_public_path__ + "static/media/children.c6881403.png";